import { render, staticRenderFns } from "./AlokasiDetail.vue?vue&type=template&id=07eb29da&scoped=true&"
import script from "./AlokasiDetail.vue?vue&type=script&lang=js&"
export * from "./AlokasiDetail.vue?vue&type=script&lang=js&"
import style0 from "./AlokasiDetail.vue?vue&type=style&index=0&id=07eb29da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eb29da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Project/Gitpanda/Agroforestcape/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VContainer,VFlex,VLayout})
